import React from 'react'
import { Calendar, Input, SectionHeader } from '@base'
import { strings } from '@constants'
import { SingleItemWrapper, StepWrapper } from '../../style'

const PriceValidityAndMOQ = ({ state, valueChangeHandler }) => {
	return (
		<StepWrapper>
			<SectionHeader>{strings('price_validity_moq')}</SectionHeader>
			<SingleItemWrapper>
				<Calendar
					label={strings('label_select_validity_date')}
					value={state.enquiryQuote?.quote_valid_till}
					onChange={(v) => valueChangeHandler(null, 'quote_valid_till')(v)}
					position='top'
				/>
			</SingleItemWrapper>
			<SingleItemWrapper>
				<Input
					id='quote-moq'
					label={strings('label_minimum_order_quantity')}
					type='number'
					placeholder={strings('placeholder_enter_minimum_order_quantity')}
					value={state?.enquiryQuote?.minimum_order_quantity}
					onChange={valueChangeHandler(null, 'minimum_order_quantity')}
				/>
			</SingleItemWrapper>
		</StepWrapper>
	)
}

export default PriceValidityAndMOQ
